import './bootstrap';

import PageHeader from './components/PageHeader';
import HeightTransition from './components/HeightTransition';
import Dropdown from './components/Dropdown';
import ModelStatusDropdown from './components/ModelStatusDropdown';
import Toggles from './components/Toggles';
import TogglesItem from './components/TogglesItem';
import Tabs from './components/Tabs';
import TabsItem from './components/TabsItem';
import Repeater from './components/Repeater';
import RepeaterItem from './components/RepeaterItem';
import Modal from './components/Modal';
import MediaPicker from './components/MediaPicker';
import MediaLibrary from './components/MediaLibrary';
import MediaEditor from './components/MediaEditor';
import Medium from './components/Medium';
import Editor from './components/Editor';
import SlugInput from './components/SlugInput';
import MoveDom from './directives/move-dom';
import HideOnScroll from './directives/hide-onscroll';
import IconLibrary from './components/IconLibrary';
import Appearance from './components/Appearance';
import Focus from './directives/focus';
import Sortable from './components/Sortable.js';
import Toaster from './components/Toaster';
import HideOnfocus from './directives/hide-onfocus';
import CharCountdown from './components/CharCountdown';
import TrialPage from './components/TrialPage';
import Pricing from './components/Pricing';
import FeedbackForm from './components/FeedbackForm';
import Billing from './components/Billing';
import Subscriptions from './components/Subscriptions';
import Subscription from './components/Subscription';
import CheckoutModal from './components/CheckoutModal';
import SvgIcon from './components/SvgIcon';
import AjaxInput from './components/AjaxInput';
import CopyToClipboard from './directives/copy-to-clipboard';
import OnClickSelect from './directives/onclick-select';

Vue.component('page-header', PageHeader);
Vue.component('height-transition', HeightTransition);
Vue.component('dropdown', Dropdown);
Vue.component('model-status-dropdown', ModelStatusDropdown);
Vue.component('toggles', Toggles);
Vue.component('toggles-item', TogglesItem);
Vue.component('tabs', Tabs);
Vue.component('tabs-item', TabsItem);
Vue.component('repeater', Repeater);
Vue.component('repeater-item', RepeaterItem);
Vue.component('modal', Modal);
Vue.component('slug-input', SlugInput);
Vue.component('sortable', Sortable);
Vue.component('toaster', Toaster);
Vue.component('char-countdown', CharCountdown);
Vue.component('svg-icon', SvgIcon);
Vue.component('feedback-form', FeedbackForm);
Vue.component('subscriptions', Subscriptions);
Vue.component('subscription', Subscription);
Vue.component('checkout-modal', CheckoutModal);
Vue.component('ajax-input', AjaxInput);
Vue.component('media-library', MediaLibrary);
Vue.component('media-editor', MediaEditor);


Vue.directive('focus', Focus)
Vue.directive('move-dom', MoveDom);
Vue.directive('hide-onscroll', HideOnScroll);
Vue.directive('hide-onfocus', HideOnfocus);
Vue.directive('copy-to-clipboard', CopyToClipboard);
Vue.directive('onclick-select', OnClickSelect);


const admin = new Vue({
    el: '#app',

    components:
    {
        IconLibrary, MediaPicker, Medium, Editor, Appearance, TrialPage, Pricing, Billing, AjaxInput
    },

    data()
    {
        return {
            contentView: "main",
            burgerMenuVisible: false,
            attachedMedia: null,
            modelType: null,
            modelId: null,
            modifiedFields: new Set,
            beforeLeavePrompt: true
        }
    },

    created()
    {
        // retrieve media for EvilCorp storage
        let vm = this
        if (typeof Pixenio != 'undefined' && Pixenio.hasOwnProperty('modelType') && Pixenio.hasOwnProperty('modelId') ) {
            vm.$evilCorp.modelType = vm.modelType = Pixenio.modelType;
            vm.$evilCorp.modelId = vm.modelId = Pixenio.modelId;
            vm.$evilCorp.siteHashid = Pixenio.siteHashid;
            let url = `/admin/ajax/media/${this.modelType}/${this.modelId}`;

            if (typeof Pixenio != 'undefined' && Pixenio.hasOwnProperty('locale')) {
                url += `/${Pixenio.locale}`;
            }
            axios.get(url).then((response) => {
                vm.attachedMedia = response.data
                this.$evilCorp.addMedia(response.data);
            }).catch(error => {
                console.log(error);
            });
        }
    },


    mounted() {
        this.$bus.$on('view-changed', view => { this.contentView = view });

        this.$bus.$on('use-media-from-library', this.onNewMediaFromLibrary);
        this.$bus.$on('use-media-from-media-picker', this.uploadImages);
        this.$bus.$on('editor-image-clicked', this.onEditorImageClicked);
        this.$bus.$on('update-medium', this.onUpdateMedium);
        this.$bus.$on('delete-medium', this.onDeleteMedium);

        this.initBeforeLeavePrompt();
    },


    methods: {
        onEditorImageClicked(id) {
            let medium;
            let found = this.$evilCorp.media.some(function(obj, index) {
                medium = obj;
                return obj.id == id;
            });

            if (!found) return;

            this.$bus.$emit('openMediaEditor', medium);
        },

        onNewMediaFromLibrary(media, type) {
            // do not close media library immediately if unsplash image is uploaded in visual editor
            // because there isn't progressbar
            if (!(this.$evilCorp.mediaContext === 'content' && type === 'unsplash')) {
                this.$bus.$emit('closeMediaLibrary');
            }

            switch (type) {
                case 'unsplash':
                    this.uploadUnsplashImages(media);
                    break;
                case 'icons':
                    this.uploadIcons(media);
                    break;
                default:
                    this.uploadImages(media);
                    break;
            }
        },

        uploadUnsplashImages(images) {
            this.$evilCorp.uploadingMedia[this.$evilCorp.mediaContext] = {total: images.length, remaining: images.length};
            this.$bus.$emit('update-media-progressbar', this.$evilCorp.mediaContext, this.$evilCorp.mediaProgressBarValue(this.$evilCorp.mediaContext));

            for (var i = 0; i < images.length; i++) {
                this.uploadUnsplashImage(images[i]);
            }
        },

        uploadUnsplashImage(image) {
            let formData = new FormData();
            formData.append('type', 'image');
            formData.append('original_source', 'unsplash');
            formData.append('context', this.$evilCorp.mediaContext);
            formData.append('model', this.modelType);
            formData.append('modelId', this.modelId);
            formData.append('unsplash_image', JSON.stringify(image));

            const context = this.$evilCorp.mediaContext;

            axios.post(`/admin/ajax/media`,
                formData
            ).then((response) => {
                this.$evilCorp.uploadingMedia[context].remaining--;
                this.$bus.$emit('update-media-progressbar', context, this.$evilCorp.mediaProgressBarValue(context));

                this.addMedia(response.data);

            }).catch(error => {
                let errors = error.response.data.errors;
            });
        },

        uploadIcons(icons) {
            for (var i = 0; i < icons.length; i++) {
                this.uploadIcon(icons[i]);
            }
        },

        uploadIcon(icon) {
            let formData = new FormData();
            formData.append('type', 'icon');
            formData.append('original_source', icon.id);
            formData.append('context', this.$evilCorp.mediaContext);
            formData.append('model', this.modelType);
            formData.append('modelId', this.modelId);

            axios.post(`/admin/ajax/media`, formData).then((response) => {
                this.addMedia(response.data);
            }).catch((error) => {
                this.$bus.$emit('adding-media-failed', error, context);
            });
        },

        uploadImages(files) {
            this.$evilCorp.uploadingMedia[this.$evilCorp.mediaContext] = {total: files.length, remaining: files.length};
            this.$bus.$emit('update-media-progressbar', this.$evilCorp.mediaContext, this.$evilCorp.mediaProgressBarValue(this.$evilCorp.mediaContext));

            for (var i = 0; i < files.length; i++) {
                this.uploadImage(files[i]);
            }
        },

        uploadImage(image) {
            let formData = new FormData();
            formData.append('type', 'image');
            formData.append('context', this.$evilCorp.mediaContext);
            formData.append('model', this.modelType);
            formData.append('modelId', this.modelId);
            formData.append('image', image);

            const context = this.$evilCorp.mediaContext;

            axios.post(`/admin/ajax/media`, formData).then((response) => {
                this.addMedia(response.data);
                this.$evilCorp.uploadingMedia[context].remaining--;
                this.$bus.$emit('update-media-progressbar', context, this.$evilCorp.mediaProgressBarValue(context));
            }).catch((error) => {
                this.$evilCorp.uploadingMedia[context].remaining--;
                this.$bus.$emit('update-media-progressbar', context, this.$evilCorp.mediaProgressBarValue(context));
                this.$bus.$emit('adding-media-failed', error, context);
            });
        },

        onUpdateMedium(medium) {
			axios.patch(`/admin/ajax/media/${medium.id}`, medium.data).then((response) => {
                this.$evilCorp.updateMedium(response.data);
                this.$bus.$emit('closeMediaEditor');

                if (response.data.context === 'content') {
                    this.$bus.$emit('updated-image-in-editor', response.data);
                }
			}).catch(error => {

			});
        },

        onDeleteMedium(medium) {
            // if medium is deleted from visual editor's content do not delete it from database
            // such medium will be processed when content is saved
            if (medium.context === 'content') {
                this.$bus.$emit('delete-image-from-editor', medium.id);
                this.$bus.$emit('closeMediaEditor');
                this.$evilCorp.deleteMedium(medium);

                return;
            }

			axios.delete(`/admin/ajax/media/${medium.id}`).then((response) => {
                this.$bus.$emit('closeMediaEditor');
                this.$evilCorp.deleteMedium(medium);
			}).catch((error) => {
				console.log(error);
			});
        },

        addMedia(medium) {
            // this.attachedMedia.push(medium);
            this.$evilCorp.addMedia(medium);

            if (medium.context === 'content') {
                this.$bus.$emit('new-image-for-editor', medium);
            }
        },

        initBeforeLeavePrompt() {
            addEventListener('beforeinput', this.setFieldDefaultValue);
            addEventListener('input', this.updateModifiedFields);
            addEventListener('beforeunload', this.changesMade);
            addEventListener('submit', () => { this.beforeLeavePrompt = false; });
            this.$bus.$on('before-leave', enable => { this.beforeLeavePrompt = enable; });
        },

        setFieldDefaultValue(e) {
            const target = e.target;
            if (!('defaultValue' in target || 'defaultValue' in target.dataset)) {
                target.dataset['defaultValue'] = this.createDefaultValueString(target.value, target.textContent);
            }
        },

        createDefaultValueString(sourceVal, defaultVal) {
            return ("" + (sourceVal || defaultVal || '')).trim();
        },

        updateModifiedFields(e) {
            const target = e.target;
            // if input has dataset 'prevent-leave-prompt' it means we do not watch this input
            if (target.dataset.preventLeavePrompt !== undefined) return;

            let original;
            let type = e.target.type || false;

            if (type == "checkbox" || type == "radio") {
                original = target['defaultChecked'];
            } else if (type == "select-one") {
                for (var i = 0 ; i < target.length ; i++) {
                    if (target[i].defaultSelected) original = i;
                }
            } else {
                original = 'defaultValue' in target ? target['defaultValue'] : target.dataset['defaultValue'] || '';
            }

            if (((type == "checkbox" || type == "radio") && original != target.checked)
            || (type == "select-one" && original != target.selectedIndex)
            || ((type != "checkbox" && type != "radio" && type != "select-one" && type != "file") && original !== this.createDefaultValueString(target.value, target.textContent))) {
                if (!this.modifiedFields.has(target)) {
                    this.modifiedFields.add(target);
                }
            } else if (this.modifiedFields.has(target)) {
                this.modifiedFields.delete(target);
            }
        },

        changesMade(e) {
            var modifiedFieldsArray = Array.from(this.modifiedFields) || [];
            if (!(this.beforeLeavePrompt && this.modifiedFields.size && modifiedFieldsArray.filter(obj => document.body.contains(obj)).length)) return;

            if (modifiedFieldsArray[0]
            && modifiedFieldsArray[0].dataset['defaultValue'] === this.createDefaultValueString(modifiedFieldsArray[0].value, modifiedFieldsArray[0].textContent)) {
                this.modifiedFields.clear();
                return;
            }

            const msg = this.$t__('Changes you made may not be saved.');
            e.returnValue = msg;
            return msg;
        },

        onFeedbackModalOpen() {
            /* Typeform */

            const lsn = "pxn.feedbackForm.typeformFinished";
            var typeformWidget = this.$refs.feedbackModal.$el.querySelector('.typeform-widget');

            if (!typeformWidget) return;

            if (localStorage.getItem(lsn)) {
                typeformWidget.classList.add('display-none');
                return;
            }

            typeformEmbed.makeWidget(
                typeformWidget, // el
                'https://pixenio1.typeform.com/to/NfTeje', // form url
                {
                    "opacity": 0,
                    "hideHeaders": true,
                    "hideFooter": true,
                    "buttonText": this.$t__('Rate Pixenio'),
                    "onSubmit": () => {
                        localStorage.setItem(lsn, true);
                    }
                }
            );
        },

        requestAccountDeletion() {
            const deleteButton = this.$refs.deleteAccountButton;
            axios.get(deleteButton.getAttribute('data-route')).then(response => {
                deleteButton.disabled = true;
                deleteButton.classList.add('opacity-half');
                deleteButton.innerHTML = response.data.message;
                this.$refs.deleteAccountModal.close();
            }).catch(error => {
                console.log(error.response);
                if (error.response.status === 403) {
                    deleteButton.innerHTML = error.response.statusText;
                    deleteButton.disabled = true;
                    deleteButton.classList.add('opacity-half');
                }
                this.$refs.deleteAccountModal.close();
            });
        }
    }
});
